import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { getStudents, deleteStudent, getStudentById } from "../../../../services/studentService";
import { message } from "antd";
import { StudentType } from "../../../../types/studentTypes";

const useStudentManagement = (
) => {
  const { t } = useTranslation();
  const [students, setStudents] = useState<StudentType[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const [student, setStudent] = useState<StudentType | null>(null);
  const [pagination, setPagination] = useState<any>({
    page: 1,
    limit: 10,
    total: 0,
  });

  useEffect(() => {
    fetchStudents();
  }, []);

  const fetchStudents = async (filters: any = { page: 1, limit: 10 }) => {
    setIsLoading(true);
    try {
      const response = await getStudents(filters);
      setStudents(response.data);
      setPagination(response.pagination)
    } catch (error) {
      message.error(t("failed_to_fetch_students"));
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteStudent = async (studentId: string) => {
    setIsDeleting(true);
    try {
      await deleteStudent(studentId);
      message.success(t("student_deleted_successfully"));
      // setStudents((prevStudents) => prevStudents.filter((s) => s.id !== studentId));
      fetchStudents()
    } catch (error) {
      message.error(t("failed_to_delete_student"));
    } finally {
      setIsDeleting(false);
    }
  };

  const fetchStudentById = async (studentId: string) => {
    try {
      const response = await getStudentById(studentId);
      return response.data;
    } catch (error) {
      message.error(t("failed_to_fetch_student"));
    }
  };

  return {
    students,
    isLoading,
    isDeleting,
    handleDeleteStudent,
    fetchStudents, // allow manual refresh
    fetchStudentById,
    student,
    pagination
  };
};

export default useStudentManagement;
